export default __webpack_public_path__ + "static/media/missingmaps.2cf23b61.png";